import { Platform } from 'react-native';
import type { NativeStackNavigationOptions } from '@react-navigation/native-stack';

/** Default native-stack behavior: platform transitions + default edge swipe-back. */
export function createStackScreenOptions(
  ios_status_bar_style?: 'light' | 'dark',
): NativeStackNavigationOptions {
  return {
    headerShown: false,
    // Keep previous screen's native views (Main hero image/video) attached so back-nav
    // does not tear down and reload the banner.
    detachPreviousScreen: false,
    ...(Platform.OS === 'ios' && ios_status_bar_style ? { statusBarStyle: ios_status_bar_style } : {}),
  };
}
